import { createClient, postRequestFactory, SaveOperation } from '@infuse/api/common';
import { Availability } from '../model';
import { commandPermissions } from './command-permissions';
import { ConfigureResponse } from './configure';

export interface ChangeAvailabilityCommand {
  evseId: number;
  connectorId?: number;
  availability: Availability;
}

export enum ChangeAvailabilityResponseStatus {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  SCHEDULED = 'SCHEDULED'
}

const client = createClient('/rest/operator-api/charging-stations');

export const changeAvailability: SaveOperation<ChangeAvailabilityCommand, ConfigureResponse, string> =
  postRequestFactory<ChangeAvailabilityCommand, ConfigureResponse, string>(client, {
    pattern: '/{chargingStationId}/change-availability',
    permissionId: commandPermissions.REQUEST_CHARGING_STATION_CHANGE_AVAILABILITY
  });
